export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topbar-1.vue?vue&type=template&id=55fdd1ec"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/topbar/topbar-1.vue?vue&type=template&id=55fdd1ec
// module id = EtGQ
// module chunks = 0